import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { KitLayout, ReOrderLayout } from '../Layout';
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../common/GridLayout";
function ReorderTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const dataGrid = useRef(null);
    const gridKey = "746D1DB0-29CC-402A-941D-EC064B76E283";
    var url = "im/VenorCrDetail/GetVendorCrDetails";
    const dataSource = useMemo(() => createStore({
        key: 'RowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        loadParams:
        {
            ItemRowId: props.formFields.RItem,
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        }
    }), [props.formFields.RItemKittCode]);
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    var accessToken = props.oidc.user.access_token;
    const formRefs = useRef({});

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }
    const handleSelectionChange = useCallback((name, value, e) => {
    }, []);
    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='371BAD8B-ADC6-4E25-8B77-89102EE8E5A6'
                layoutName='IMLotDataEntryReorderForm'
                defaultFormSchema={ReOrderLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={(name, value, e)=>props.handleFieldChange(name, value, e,formRefs)}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={()=>props.reorderFormLoad(formRefs)}
                handleSelectedItemChange={handleSelectionChange}
            />
            <div className="col-md-12">
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    id="gridContainer"
                    onContentReady={onContentReady}
                    dataSource={dataSource}
                    ref={dataGrid}
                    selectedRowKeys={selectedItemKeys}
                    showBorders={true}
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    onSelectionChanged={handleCellValueChanged}
                    height='61vh'
                >
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={loadState}
                        storageKey={gridKey}
                        customSave={saveState}
                    />
                    <Scrolling mode="standard" />
                    <Selection mode="single" />
                    <Export enabled={true} allowExportSelectedData={true} />

                    <Paging enabled={true} defaultPageSize={10} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <Column dataField="Vendor" caption="Vendor" dataType="string" />
                    <Column dataField="VendorItemCode" caption="Vendor Item Code" dataType="string" />
                    <Column dataField="Ranking" caption="Ranking" dataType="number" />
                    <Column dataField="PurchaseUom" caption="Purchase Uom" dataType="string" />
                    <Column dataField="InventoryUom" caption="Inventory Uom" dataType="string" />
                    <Column dataField="PurchaseCost" caption="Purchase Cost" dataType="number" format={{
                        type: 'currency',
                        precision: 2,
                        currency: 'USD',
                        useGrouping: true
                    }} />
                    <Toolbar>
                        <Item location="after">
                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ReorderTab);
